import React from "react";
import {useInjection} from "inversify-react";
import {observer} from "mobx-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {BenefitItem, BenefitList, BenefitText} from "./styled";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";

type Props = { features: string[] }

const ExtensionBenefits = observer(({features}: Props) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <BenefitList>
            {features.map((feature) => (
                <BenefitItem key={feature}>
                    <DropDeskIcon icon={ICONS_DROPDESK.check} size={13} color={colors.success}/>
                    <BenefitText color={colors.hint}>{feature}</BenefitText>
                </BenefitItem>
            ))}
        </BenefitList>
    );
});

export default ExtensionBenefits;
